import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isAddToCartWarningPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { isCommonValuesForSharedItemsWereEditedSelector, isLimitedEditionSelector, expirationDateForLimitedEditionSelector, warningDialogSelector } from '../../../redux/product/product.selectors';
import { AddToCartWarningPopup as AddToCartWarningPopupComponent } from './add-to-cart-warning-popup';
const headerTextSelector = createSelector(warningDialogSelector, ({
  minQuantityPerRelatedProductError,
  minQuantityPerProductError,
  minQuantityError,
  maxQuantityError,
  embellishmentError,
  isLogoUploadedAndPriceSet,
  quantityIncrementError,
  quantityMoreThanSupplierHasError,
  superSpeedColorLimitationError
}) => {
  switch (true) {
    case minQuantityError:
      {
        return 'You have selected a quantity below the minimum allowed';
      }
    case maxQuantityError:
      {
        return 'You have selected amount over the maximum allowed';
      }
    case Boolean(quantityMoreThanSupplierHasError):
      {
        return 'Please adjust your quantity';
      }
    case quantityIncrementError:
      {
        return 'Please adjust your quantity';
      }
    case minQuantityPerProductError || minQuantityPerRelatedProductError:
      {
        return 'You have selected a quantity below the minimum allowed';
      }
    case embellishmentError:
      {
        return 'Choose your decoration method';
      }
    case !isLogoUploadedAndPriceSet:
      {
        return 'You need to upload a design';
      }
    case superSpeedColorLimitationError:
      {
        return 'Please Update Your Logo';
      }
    default:
      {
        return '';
      }
  }
});
const isOpenWarningPopupSelector = createSelector(isAddToCartWarningPopupShownSelector, isCommonValuesForSharedItemsWereEditedSelector, (isAddToCartWarningPopupShown, isCommonValuesForSharedItemsWereEdited) => {
  return isAddToCartWarningPopupShown && !isCommonValuesForSharedItemsWereEdited;
});
const isOpenConfirmSharedItemsChangesSelector = createSelector(isAddToCartWarningPopupShownSelector, isCommonValuesForSharedItemsWereEditedSelector, (isAddToCartWarningPopupShown, isCommonValuesForSharedItemsWereEdited) => {
  return isAddToCartWarningPopupShown && isCommonValuesForSharedItemsWereEdited;
});
const mapStateToProps = createStructuredSelector({
  headerText: headerTextSelector,
  isOpenWarningPopup: isOpenWarningPopupSelector,
  isOpenConfirmSharedItemsChanges: isOpenConfirmSharedItemsChangesSelector,
  isLimitedEdition: isLimitedEditionSelector,
  expirationDateForLimitedEdition: expirationDateForLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  },
  onSharedItemsChangesConfirm: () => {
    const btn = document.getElementById('submitForm');
    btn === null || btn === void 0 ? void 0 : btn.click();
    dispatch(hidePopup());
  }
});
export const AddToCartWarningPopup = connect(mapStateToProps, mapDispatchToProps)(AddToCartWarningPopupComponent);